import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CoreButton from 'frontcore/components/CoreButton.vue'
import i18n from 'frontcore/i18n'
import useLogout from 'frontcore/domain/authorization/model/useLogout'
import { LoginTypeOptions } from 'frontcore/domain/authorization/model/types'
import { useRoute } from 'vue-router'
import { watch } from 'vue'

interface Props {
  userLoginType: LoginTypeOptions
}
type LogoutEmit = (e: 'logoutSuccess') => void

export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutCoreButton',
  props: {
    userLoginType: {}
  },
  emits: ["logoutSuccess"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const route = useRoute()

const { t } = i18n.global

const {
  logout,
  continueLogoutProcess,
} = useLogout(props.userLoginType, emit)

watch(
  () => route.query.request_id,
  (newValue) => {
    if (newValue && route.query.logout === 'true') {
      continueLogoutProcess(Boolean(newValue))
    }
  }, { immediate: true }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreButton, {
    class: "tw-text-core-primary-99",
    label: _unref(t)('common.messages.logout'),
    buttonType: "secondary",
    iconName: "Logout",
    dataTest: "logout-button",
    onClick: _unref(logout)
  }, null, 8, ["label", "onClick"]))
}
}

})